import { render, staticRenderFns } from "./FlaggingDebug.vue?vue&type=template&id=56189e23"
import script from "./FlaggingDebug.vue?vue&type=script&lang=ts"
export * from "./FlaggingDebug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports